import {lazy} from 'react'

export const ColorInput = lazy(() => import('./ColorInput'))
